import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
const MobileDevPageDisplaySide300x250 = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['MobileDevPageDisplaySide300x250'], safety, {
        refreshLimit: 30,
        refreshTime: 30,
        renderVisibleOnly: true,
        refreshVisibleOnly: true,
        sizes: [
            [
                '300',
                '250'
            ]
        ],
        report: {
            enabled: false
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
MobileDevPageDisplaySide300x250.displayName = 'MobileDevPageDisplaySide300x250';
export default MobileDevPageDisplaySide300x250;
